/* =====================================================================
   SCK Recently Viewed: approved card renderer (product pages only)

   The theme's Recently Viewed logic in theme.js is kept as is: history in
   localStorage "theme-recent", newest first, current product excluded,
   desktop/mobile limits from the section settings. Only the card markup
   step changes. Instead of the old JavaScript template, each card is
   rendered by Liquid through sections/sck-card-renderer.liquid, which
   renders snippets/product-grid-item.liquid: the same card used by
   Customers Also Bought and the collection grids. Titles, images, prices,
   promotional labels and the Activity badge therefore come from current
   product data, not from the browsing-history record.

   Loaded by sections/recently-viewed.liquid on product pages.
   ===================================================================== */
(function () {
  'use strict';

  if (!window.theme || !theme.RecentlyViewed || theme.RecentlyViewed.__sckCards) return;
  if (!document.body || !document.body.classList.contains('template-product')) return;
  theme.RecentlyViewed.__sckCards = true;

  var proto = theme.RecentlyViewed.prototype;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cardCache = {};

  /* One request per product per page view; failed requests are not cached. */
  function cardFor(handle) {
    if (!cardCache[handle]) {
      cardCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=sck-card-renderer', {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var card = tmp.querySelector('.grid-product.sck-card-item');
          return card ? card.outerHTML : null;
        })
        .catch(function () {
          delete cardCache[handle];
          return null;
        });
    }
    return cardCache[handle];
  }

  /* A product that was deleted or unpublished after it was viewed used to
     reject the whole Promise.all in theme.js and leave the section empty.
     Resolve it as null instead; setupOutput already skips empty entries. */
  var getProductInfo = proto.getProductInfo;
  proto.getProductInfo = function (handle) {
    return getProductInfo.call(this, handle).catch(function () {
      return null;
    });
  };
  var captureProductDetails = proto.captureProductDetails;
  proto.captureProductDetails = function (products) {
    return captureProductDetails.call(this, (products || []).filter(Boolean));
  };

  var originalRender = proto.renderProducts;

  proto.renderProducts = function () {
    var self = this;
    if (!this.allProductsData.length) {
      this.container.classList.add('hide');
      return;
    }

    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var limit = parseInt(
      this.container.getAttribute(isMobile ? 'data-recent-count-mobile' : 'data-recent-count'),
      10
    ) || 4;

    /* theme.js calls this on every resize; only redraw when the limit changes. */
    if (this._sckLimit === limit && this.outputContainer.children.length) return;

    var token = (this._sckToken = (this._sckToken || 0) + 1);
    /* A few extra candidates so a product that cannot be rendered does not
       shorten the row. Order is the theme's history order. */
    var candidates = this.allProductsData.slice(0, limit + 3);

    Promise.all(candidates.map(function (product) {
      return cardFor(product.handle);
    })).then(function (cards) {
      if (token !== self._sckToken) return;
      var markup = cards.filter(Boolean).slice(0, limit).join('');

      if (!markup) {
        /* Renderer unavailable: fall back to the theme's own cards. */
        originalRender.call(self);
        self._sckLimit = limit;
        return;
      }

      self.container.classList.remove('hide');
      self.outputContainer.innerHTML = markup;
      self._sckLimit = limit;
      if (window.AOS) AOS.refreshHard();
      document.dispatchEvent(new CustomEvent('sck:recently-viewed:rendered', {
        detail: { container: self.container }
      }));
    });
  };

  /* The product image sits outside the card link in product-grid-item, as
     in Customers Also Bought, whose section script makes the image area
     open the product. Same behaviour here. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var wrapper = target.closest('.sck-rv .grid__item-image-wrapper');
    if (!wrapper || target.closest('a, button')) return;
    var link = wrapper.querySelector('a.grid-product__link');
    if (!link) return;
    event.preventDefault();
    if (event.metaKey || event.ctrlKey) {
      window.open(link.href, '_blank');
    } else {
      window.location.href = link.href;
    }
  });
})();
